import * as React from "react";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { GlobalErrorPage } from "@/interface/pages/global-error-page";
import { NotFoundPage } from "@/interface/pages/not-found-page";

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: GlobalErrorPage,
  notFoundComponent: NotFoundPage,
});

function RootComponent() {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}
